import { render, staticRenderFns } from "./photo-camera.vue?vue&type=template&id=948e7a5a&scoped=true"
import script from "./photo-camera.vue?vue&type=script&lang=js"
export * from "./photo-camera.vue?vue&type=script&lang=js"
import style0 from "./photo-camera.vue?vue&type=style&index=0&id=948e7a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948e7a5a",
  null
  
)

export default component.exports